/**
 * Valores em lamports viajam como STRING de dígitos.
 *
 * Lamports não cabem com segurança num número de JSON: `2^53` já é menos que
 * o supply, e um valor arredondado em trânsito é dinheiro errado. Quem recebe
 * lê com `BigInt`.
 *
 * O teto de dígitos é a guarda antes do `BigInt`: sem ele, uma string de mil
 * dígitos entraria no parse só para estourar depois.
 */
export const TETO_DIGITOS_VALOR = 40
